import '../scss/pfields/PcheckboxGroup.scoped.scss';
import Pcheckbox from './Pcheckbox';

function PcheckboxGroup({pfield}) {
  let lol = pfield.obj.querySelector('label').textContent;
  let classes = ["pf-checkboxes"];
  if(pfield.dependent) {
    classes.push("hidden");
  }
  if(pfield.error) {
    classes.push("error");
  }
  classes = classes.concat(pfield.eclasses);
  return(
    <div className={classes.join(' ')} id={'d' + pfield.id}>
      {pfield.error ? <p>{pfield.errtxt}</p> : "" }
      <h3>{lol}</h3>
      <div className="checkboxes">
        {
          pfield.children.map((ck) => (
            <Pcheckbox 
              pfield={ck} 
              key={ck.id}
              id={ck.id}
            />))
        }
      </div>
    </div>
  );

}

export default PcheckboxGroup;